import React from 'react';

import { SearchItem } from './SearchItem';
import { SearchItemLoading } from './SearchItemLoading';
import { NumberedPagination } from '../common/pagination/NumberedPagination';
import { Component } from '../common/ui/Component';

export const SearchItemList = ({
    isLoading,
    data,
    onPrevious,
    onNext,
    onPage,
    onAddItem,
    addItemText
}) => {
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-12">
                    <ul className="list-group mt-3 mb-3">
                        <li className="list-group-item">
                            <div className="row d-flex d-md-none">
                                <div className="col">
                                    <p className="text-center mb-0">
                                        <strong>Gifts</strong>
                                    </p>
                                </div>
                            </div>
                            <div className="row d-none d-md-flex">
                                <div className="col-md-1 col-lg-1" />
                                <div className="col-md-3 col-lg-5">
                                    <p>
                                        <strong>Name</strong>
                                    </p>
                                </div>
                                <div className="col-md-4 col-lg-3">
                                    <p className="text-end">
                                        <strong>Price</strong>
                                    </p>
                                </div>
                                <div className="col-md-4 col-lg-3" />
                            </div>
                        </li>
                        {!isLoading ? (
                            <Component
                                list={data.records}
                                element={SearchItem}
                                listProps={(item) => ({ item, onAddItem, addItemText })}
                            />
                        ) : (
                            <Component element={SearchItemLoading} size={5} />
                        )}
                    </ul>
                </div>
            </div>
            {!isLoading && (
                <NumberedPagination
                    className="align-items-center mb-0 mb-sm-3"
                    onPrevious={onPrevious}
                    onNext={onNext}
                    onPage={onPage}
                    data={data}
                />
            )}
        </React.Fragment>
    );
};
